<template>
  <div class="py-1 px-1.5">
    <div
      class="rounded-md border border-primary justify-between h-[44px] flex gap-2 items-center px-3.5"
    >
      <div class="flex gap-2 items-center">
        <div>
          <Icon name="search" class="text-placeholder" />
        </div>
        <ComboboxInput
          autoFocus
          class="p-0 w-full border-none focus:ring-0 placeholder:text-placeholder text-style-sm font-medium"
          :placeholder="placeholder || t('components.combobox.search')"
        />
      </div>
      <ComboboxCancel asChild="true" v-if="showCancel">
        <Button
          :label="cancelLabel || t('components.combobox.cancel')"
          variant="link"
          type="gray"
        />
      </ComboboxCancel>
    </div>
  </div>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";
import { Button } from "@/SharedComponents/Buttons";
import { ComboboxCancel, ComboboxInput } from "radix-vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
  showCancel: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
  },
  cancelLabel: {
    type: String,
  },
});
</script>
